import { combineReducers } from "redux";
// slices
import learnerReducer from "./slices/learner";
import facultyReducer from "./slices/faculty";
import chatButttonReducer from "./slices/chat";
// ----------------------------------------------------------------------

const rootReducer = combineReducers({
  learner: learnerReducer,
  faculty: facultyReducer,
  chat: chatButttonReducer,
});

export default rootReducer;
